module.exports = __webpack_public_path__ + "fonts_/iconfont.169d273.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/font/iconfont.ttf?t=1573030555456
// module id = 21
// module chunks = 0